export default __webpack_public_path__ + "static/media/marvelcharacters.0230a60e.gif";